import {AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {AuthService} from '../core/services';
import {first} from 'rxjs/operators';
import {ActivatedRoute, Router} from '@angular/router';
import {MessageService} from 'primeng/api';
import {RegistrationService} from '../core/services/registration.service';
import {SwiperContainer} from 'swiper/element';
import SwiperOptions from 'swiper';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit, AfterViewInit {
    @ViewChild('loginForm') loginForm: { invalid: any };
    @ViewChild('resetForm') resetForm: { invalid: any };
    @ViewChild('backgroundSwiper') backgroundSwiper!: ElementRef<SwiperContainer>;

    forgotPasswordDialog = false;

    msgs: any;

    formData = {
        username: '',
        password: '',
    };
    error: string;
    loading = false;
    email: string;
    resetSubmitted = false;
    public passwortReset: boolean;
    swiperBackgroundSlider: SwiperOptions = {
        slidesPerView: 1,
        loop: true,
        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },
        autoplay: {
            // @ts-ignore
            delay: 4000,
        },
        speed: 4000,
    };

    constructor(
        private authService: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private message: MessageService,
        private registrationService: RegistrationService
    ) {
    }

    ngOnInit(): void {
    }

    login(): void {
        if (this.loginForm.invalid) {
            this.showError($localize`:@@error.incomplete:Eingaben unvollständig`);
        } else {
            this.authService.login(this.formData.username, this.formData.password);
        }
    }

    showError(msg: string): void {
        this.message.add({
            key: 'msgs',
            severity: 'error',
            summary: $localize`:@@show.error:Fehler`,
            life: 5000,
            detail: msg,
        });
    }

    showMessage(msg: string, type = 'error', summary = 'Fehler'): void {
        this.message.add({
            key: 'msgs',
            severity: type,
            life: 5000,
            summary,
            detail: msg,
        });
    }

    public showPasswortReset(show: boolean) {
        this.passwortReset = show;
    }

    resetPasswordData(): void {
        this.resetSubmitted = true;
        if (this.resetForm.invalid) {
            this.showError($localize`:@@password.reset.error:Bitte geben Sie Ihre Email-Adresse ein!`);

            return;
        }
        this.registrationService.passwordforgot(this.email).subscribe({
            next: (d) => {
                this.forgotPasswordDialog = false;
                this.email = '';
                this.showMessage(
                    $localize`:@@password.reset.message:Wir haben Ihre Anfrage zum Zurücksetzen Ihres Passworts erhalten. Bitte prüfen Sie Ihr Email-Postfach. Sie werden in Kürze eine Email von uns mit Anweisungen zum zurücksetzen Ihres Passworts erhalten.`,
                    'success',
                    $localize`:@@successful:Erfolgreich!`
                );
            },
            error: () => {
                this.forgotPasswordDialog = false;
                this.email = '';
                this.showMessage($localize`:@@unknown.email.address:Email-Adresse nicht bekannt!`, 'error', $localize`:@@error:Fehler!`);
            },
        });
    }

    ngAfterViewInit(): void {
        this.backgroundSwiper.nativeElement.initialize();
    }
}
